import React from 'react';
import PropTypes from 'prop-types';
import { useIntl, defineMessages } from 'react-intl';

import Steven, { ELEMENT_TYPES } from 'javascripts/helpers/steven';
import CCRadioButton from 'components/shared/DesignSystem/SlabTransferPortal/CCRadioButton';
import { AND, OR } from '../constants';
import RadioWrap from './RadioWrap';
import GroupTitle from './GroupTitle';

const messages = defineMessages({
  title: {
    id: 'AssetFeed.ViewMenu.TagsOperatorToggle.title',
    defaultMessage: 'Filter Tags By',
    description: 'View menu tags operator title',
  },
  andOperator: {
    id: 'AssetFeed.ViewMenu.TagsOperatorToggle.andOperator',
    defaultMessage: 'And',
    description: 'Label for tags AND operator',
  },
  orOperator: {
    id: 'AssetFeed.ViewMenu.TagsOperatorToggle.orOperator',
    defaultMessage: 'Or',
    description: 'Label for tags OR operator',
  },
});

const TagsOperatorToggle = ({ onChange, selected }) => {
  const { formatMessage } = useIntl();

  return (
    <div>
      <GroupTitle>{formatMessage(messages.title)}</GroupTitle>
      <RadioWrap>
        <CCRadioButton
          id="tags_operator_or_button"
          label={formatMessage(messages.orOperator)}
          value={OR}
          layout="inline"
          name="tags_operator_or"
          onChange={(checked) => {
            if (checked) {
              onChange(OR);
            }
          }}
          checked={selected === OR}
          data-testid="view_menu__filter-or"
        />
        <CCRadioButton
          id="tags_operator_and_button"
          label={formatMessage(messages.andOperator)}
          value={AND}
          layout="inline"
          name="tags_operator_and"
          onChange={(checked) => {
            if (checked) {
              onChange(AND);
              Steven.elementClicked({
                id: 'tags_operator_and_button',
                content: 'And',
                type: ELEMENT_TYPES.BUTTON,
                action: 'tags_operator_changed',
              });
            }
          }}
          checked={selected === AND}
          data-testid="view_menu__filter-and"
        />
      </RadioWrap>
    </div>
  );
};

TagsOperatorToggle.propTypes = {
  onChange: PropTypes.func.isRequired,
  selected: PropTypes.string.isRequired,
};

export default TagsOperatorToggle;
